/**
 * Planned material input of a production order (spec 0040 §2.4).
 * Subcollection: org/{orgId}/production-order/{productionOrderId}/material
 *
 * No lifecycle. Materialized on `draft → released` from the resolved technical
 * sheet inputs (0169), scaled by the OP quantity (`plannedQuantity` =
 * `effectiveQuantity`). Empty when the OP has no sheet (D7). Resolve with
 * context `{ orgId, productionOrderId }`.
 *
 * `unitId` is omitted: `Product.unit` is a code string, not a Unit FK — do not
 * invent a catalog pointer the product does not expose.
 */
export const PRODUCTION_ORDER_MATERIAL = 'ProductionOrderMaterial';
//# sourceMappingURL=production-order-material.js.map